import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ADMIN_ROUTES } from './admin.routes';
import { BillingEffects } from './billing/effects/billing.effects';
import { DashboardEffects } from './dashboard/effects/dashboard.effects';
import { GroupsEffects } from './groups/effects/groups.effects';
import { GuestsEffects } from './guests/effects/guests.effects';
import { MembersEffects } from './members/effects/members.effects';
import { ProvisioningEffects } from './provisioning/effects/provisioning.effects';
import * as fromAdmin from './reducers';
import { SsoEffects } from './sso/effects/sso.effects';
import { TeamsEffects } from './teams/effects/teams.effects';
import { TransfersEffects } from './transfers/effects/transfers.effects';
import { SecurityEffects } from './security/effects/security.effects';
import { PlanDurationInYearOrMonthPipe } from '@app/shared/pipes/plan-duration-year-or-month.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ADMIN_ROUTES),
    StoreModule.forFeature(fromAdmin.adminFeatureKey, fromAdmin.reducers),
    EffectsModule.forFeature([BillingEffects, GuestsEffects, MembersEffects, TeamsEffects, SsoEffects, GroupsEffects, TransfersEffects, ProvisioningEffects, DashboardEffects, SecurityEffects]),
  ],
  providers: [PlanDurationInYearOrMonthPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdminModule { }
